export default "__VITE_ASSET__CqOA9aNV__";